// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"e760b362","796":"d54ab267"}[chunkId] + ".chunk.js";
};